import React from "react";

import ReviewFormScreen from "./ReviewFormScreen";

const NewReviewScreen = () => {
  return <ReviewFormScreen review={null} reviewLoading={false} />;
};

export default NewReviewScreen;
